import { render, staticRenderFns } from "./pagination-local.vue?vue&type=template&id=becda796"
import script from "./pagination-local.vue?vue&type=script&lang=js"
export * from "./pagination-local.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports